import React from 'react';
import { AlertTriangle } from 'lucide-react';
import './App.css';

interface ConfirmModalProps {
    isOpen: boolean;
    title: string;
    message: string;
    onConfirm: () => void;
    onCancel: () => void;
}

export const ConfirmModal: React.FC<ConfirmModalProps> = ({ isOpen, title, message, onConfirm, onCancel }) => {
    if (!isOpen) return null;

    return (
        <div className="modal-overlay">
            <div className="modal-content" style={{ maxWidth: '400px', textAlign: 'center' }}>
                <div style={{ marginBottom: 16 }}>
                    <AlertTriangle size={48} color="#ef4444" strokeWidth={1.5} />
                </div>
                <h2 style={{ marginBottom: '12px', color: '#fff' }}>{title}</h2>
                <p style={{ color: 'var(--text-muted)', marginBottom: '24px' }}>{message}</p>

                <div style={{ display: 'flex', gap: '12px', justifyContent: 'center' }}>
                    <button className="btn-cancel" onClick={onCancel} style={{ minWidth: '120px' }}>
                        Cancelar
                    </button>
                    <button
                        className="btn-destructive"
                        onClick={onConfirm}
                        style={{ minWidth: '120px' }}
                    >
                        Confirmar
                    </button>
                </div>
            </div>
        </div>
    );
};
